import {
  Directive,
  ElementRef,
  inject,
  OnInit,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appQmBlock]',
  standalone: true,
})
export class QMBlockDirective implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly hostElement = inject(ElementRef);

  ngOnInit(): void {
    this.renderer.setAttribute(
      this.hostElement.nativeElement,
      'data-qm-block',
      'true',
    );
  }
}
